import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import Container from '@mui/material/Container'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import MenuItem from '@mui/material/MenuItem'
import ReactOnRails from 'react-on-rails'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { Link } from '@mui/material'
import { useCurrentUser } from './CurrentUserContext'

const pages = [
  { title: 'About', link: '/about' },
  { title: 'Contact', link: '/contact' },
]

function Header() {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null)
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null)
  const { currentUser, fetchCurrentUser } = useCurrentUser()
  const navigate = useNavigate()
  const theme = useTheme()

  React.useEffect(() =>  {
    console.log('RENDERING HEADER')
    fetchCurrentUser(), []
  })


  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const handleSettingsSelect = () => {
    window.location.href = '/settings'
  }

  const handleEmbedSelect = () => {
    window.location.href = '/embed'
  }

  const handleManageEventsSelect = () => {
    if(!currentUser) {
      handleCloseNavMenu()
    } else {
      window.location.href = `/org/${currentUser.organization.slug}`
    }
  }

  const handleOnLoginClick = () => {
    window.location.href = '/users/sign_in'
  }

  const handleNavItemClick = (link) => {
    handleCloseNavMenu()
    navigate(link)
  }

  const handleLogout = async () => {
    await fetch('/users/sign_out', {
      headers: {
        'X-CSRF-Token': ReactOnRails.authenticityToken(),
        'Content-Type': 'application/json',
      },
      method: 'DELETE'
    })

    // refresh the page
    window.location.reload()
  }

  return (
    <AppBar position="static" sx={{height: 64}}>
      <Container maxWidth="xl" sx={{height: 64}}>
        <Toolbar disableGutters sx={{height: 64}}>
          <Link
            href={'/'}
            sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', justifyContent: 'center', marginTop: 0, paddingTop: 0}}
          >
            <Box
              component="img"
              sx={{
          maxHeight: 60,
          paddingTop: 0,
          marginTop: 0,
          paddingRight: 1,
          paddingLeft: 1,
          bgcolor: 'background.default',
              }}
              alt="logo"
              src={ theme.palette.mode === 'light' ? '/test_cropped_light_mode.svg' :  '/test_cropped_dark_mode.svg' }
            />
          </Link>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', sm: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', sm: 'none' },
              }}
            >
              {
                currentUser &&
                  <MenuItem key={'Dashboard'} onClick={() => {window.location.href = `/org/${currentUser.organization.slug}`}}>
                    <Typography textAlign="center">{'Dashboard'}</Typography>
                  </MenuItem>
              }
              {pages.map((page) => (
                <MenuItem key={page.title} onClick={() => {handleNavItemClick(page.link)}}>
                  <Typography textAlign="center">{page.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Link
            href={'/'}
            sx={{ display: { xs: 'flex', sm: 'none' }, alignItems: 'center', justifyContent: 'center', flexGrow: (currentUser ? 4 : 1), mr: (currentUser ? 3 : 0)}}
          >
            <Box
              component="img"
              sx={{
          maxHeight: 55,
          paddingTop: 0,
          marginTop: 0,
          paddingRight: 1,
          paddingLeft: 1,
          bgcolor: 'background.default',
              }}
              alt="logo"
              src={ theme.palette.mode === 'light' ? '/test_cropped_light_mode.svg' :  '/test_cropped_dark_mode.svg' }
            />
          </Link>
          <Box sx={{ flexGrow: 1, paddingLeft: 1, display: { xs: 'none', sm: 'flex' } }}>
            {
              currentUser &&
                <Button
                  key={'Dashboard'}
                  onClick={() => {window.location.href = `/org/${currentUser.organization.slug}`}}
                  sx={{ my: 2, color: 'white', display: 'block' }}
                >
                  {'Dashboard'}
                </Button>
              }
            {pages.map((page) => (
              <Button
                key={page.title}
                onClick={() => {handleNavItemClick(page.link)}}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page.title}
              </Button>
            ))}
          </Box>

          { currentUser &&
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp"/>
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem onClick={handleManageEventsSelect}>
                  <Typography textAlign="center">Manage Events</Typography>
                </MenuItem>
                <MenuItem onClick={handleSettingsSelect}>
                  <Typography textAlign="center">Settings</Typography>
                </MenuItem>
                <MenuItem onClick={handleEmbedSelect}>
                  <Typography textAlign="center">Embed</Typography>
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <Typography textAlign="center">Logout</Typography>
                </MenuItem>
              </Menu>
            </Box>
        }
        {
          !currentUser &&
            <Button sx={{color: 'inherit'}} variant="text" onClick={handleOnLoginClick}>Admin Login</Button>
        }
        </Toolbar>
      </Container>
    </AppBar>
  )
}
export default Header
